var map = {
	"./android.svg": 9920,
	"./angularjs.svg": 8734,
	"./aws.svg": 5950,
	"./bootstrap.svg": 8983,
	"./csharp.svg": 3290,
	"./css3.svg": 7455,
	"./dart.svg": 6116,
	"./dot_net.svg": 3404,
	"./dotnetcore.svg": 7132,
	"./email.svg": 1089,
	"./express.svg": 2785,
	"./facebook.svg": 3479,
	"./figma.svg": 2005,
	"./flask.svg": 8356,
	"./flutter.svg": 2103,
	"./git.svg": 5021,
	"./github.svg": 7394,
	"./go.svg": 6917,
	"./googlecloud.svg": 1461,
	"./gratervue.svg": 8282,
	"./heroku.svg": 7991,
	"./html5.svg": 9585,
	"./instagram.svg": 5373,
	"./java.svg": 771,
	"./javascript.svg": 5602,
	"./jest.svg": 3913,
	"./jira.svg": 1495,
	"./jquery.svg": 8821,
	"./json.svg": 5597,
	"./linkedin.svg": 6049,
	"./mapbox.svg": 2710,
	"./markdown.svg": 5056,
	"./materialui.svg": 6994,
	"./microsoftsqlserver.svg": 3078,
	"./mongodb.svg": 255,
	"./mongoose.svg": 4000,
	"./mysql.svg": 9163,
	"./netlify.svg": 942,
	"./node.svg": 8723,
	"./notion.svg": 8440,
	"./npm.svg": 8186,
	"./nuget.svg": 3892,
	"./nuxtjs.svg": 3153,
	"./oracle.svg": 3689,
	"./php.svg": 1681,
	"./postgresql.svg": 7893,
	"./postman.svg": 9463,
	"./python.svg": 969,
	"./rails.svg": 4966,
	"./react.svg": 8032,
	"./render.svg": 2739,
	"./repo.svg": 2243,
	"./ruby.svg": 7739,
	"./sass.svg": 3697,
	"./servicenow.svg": 8664,
	"./socketio.svg": 2844,
	"./sqlite.svg": 5587,
	"./subversion.svg": 7305,
	"./swagger.svg": 5081,
	"./swift.svg": 8212,
	"./typescript.svg": 3330,
	"./version.svg": 5801,
	"./vite.svg": 6493,
	"./vuejs.svg": 2228,
	"./weather.svg": 725,
	"./xd.svg": 1063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;